(() => {
  const acronyms = {bmw:'BMW',gmc:'GMC',vw:'VW',mg:'MG',amg:'AMG',hsv:'HSV',fpv:'FPV',suv:'SUV',gt:'GT',gtr:'GT-R',mr2:'MR2',mx5:'MX5',vf:'VF',ve:'VE',fg:'FG',ba:'BA',bf:'BF',xy:'XY',xw:'XW'};
  function pretty(value) {
    return value.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim().split(' ').map(word => {
      const lower = word.toLowerCase();
      return acronyms[lower] || (/\d/.test(word) ? word.toUpperCase() : lower.charAt(0).toUpperCase() + lower.slice(1));
    }).join(' ');
  }
  function selectedVehicle(search) {
    const rq = new URLSearchParams(search).get('rq');
    if (!rq || rq.length > 600) return '';
    const fields = Object.create(null);
    rq.split('__').forEach(part => {
      const index = part.indexOf('_');
      if (index < 1) return;
      const key = part.slice(0, index).toLowerCase();
      let value = part.slice(index + 1);
      try { value = decodeURIComponent(value); } catch (_) {}
      if (['mk','md','yr'].includes(key) && /^[\p{L}\p{N} _().&+\/-]+$/u.test(value)) fields[key] = pretty(value);
    });
    if (!fields.mk || !fields.md || !/^\d{4}$/.test(fields.yr || '')) return '';
    return [fields.yr, fields.mk, fields.md].join(' ');
  }
  function update() {
    const badge = document.getElementById('cop-fit-badge');
    if (!badge) return;
    const vehicle = selectedVehicle(window.location.search);
    const text = document.getElementById('cop-fit-text');
    const sub = document.getElementById('cop-fit-sub');
    badge.hidden = !vehicle;
    sub.hidden = true;
    if (vehicle) {
      text.textContent = vehicle;
    } else {
      let previous = '';
      try { previous = sessionStorage.getItem('cop_vehicle') || ''; } catch (_) {}
      if (previous) {
        sub.replaceChildren();
        const link = document.createElement('a');
        link.href = (window.Shopify?.routes?.root || '/') + '#ymm_searchbox_cont';
        link.textContent = 'Check this size fits your ' + previous;
        sub.appendChild(link);
        sub.hidden = false;
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('popstate', update);
})();
